const metrics = [
  {
    value: "47",
    unit: "次",
    label: "需解释的票数跳涨",
    desc: "来自公开榜单的分钟级快照比对",
    highlight: true,
  },
  {
    value: "3.2",
    unit: "票",
    label: "单个账号平均投票数",
    desc: "统计样本覆盖 6 场公开投票赛事",
  },
  {
    value: "38",
    unit: "%",
    label: "账目明细完整度",
    desc: "抽查 21 个后援会集资公示的平均值",
  },
  {
    value: "2:00",
    unit: "前后",
    label: "异常最集中时段",
    desc: "凌晨两点的跳涨占全部异常的一半以上",
  },
];

export default function StatBoard() {
  return (
    <section className="bg-foreground-950 text-background-100">
      <div className="px-4 md:px-6 xl:px-10 py-14 md:py-20">
        <div className="max-w-[1320px] mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
            <div>
              <p className="text-xs tracking-[0.3em] text-accent-400 mb-2">DATA BOARD</p>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">热榜刻度盘</h2>
            </div>
            <p className="text-sm text-background-400 max-w-[420px]">
              下面这些数字，来自我们对公开榜单与集资记录的整理。它们不指向具体的人，只描述一个现象。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-background-800/60 rounded-lg overflow-hidden">
            {metrics.map((item) => (
              <div key={item.label} className="bg-foreground-950 p-6 md:p-7">
                <div className="flex items-baseline gap-1">
                  <span
                    className={
                      item.highlight
                        ? "font-heading text-4xl md:text-5xl font-black text-accent-400"
                        : "font-heading text-4xl md:text-5xl font-black text-background-50"
                    }
                  >
                    {item.value}
                  </span>
                  <span className="text-sm text-background-400">{item.unit}</span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-background-100">{item.label}</h3>
                <p className="mt-2 text-xs leading-relaxed text-background-500">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}